import React, { useMemo } from 'react'

import { Tabs, Tab, makeStyles, Box, Divider } from '@material-ui/core'
import { useTranslation } from 'next-i18next'

import { orderStatusToTextMap, orderStatusToTextMapEng } from '../utility/trackingUtility'

const useStyles = makeStyles((theme) => ({
    tabs: {
        // border: '1px solid black',
    },
    labelWrapper: {
        display: 'flex',
        alignItems: 'center',

        fontFamily: 'Kanit',
        // fontSize: '16px',

        '& > div': {
            marginLeft: '8px',
        }
    },
    circleBox: {
        color: '#fff',

        fontSize: '14px',

        width: '20px',
        height: '20px',

        borderRadius: '50%',

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    normal: {
        backgroundColor: '#828282',
    },
    active: {
        backgroundColor: theme.palette.primary.main,
    }
}))

const TrackingTab = ({ setTab, tab, data, onResetOpen }) => {
    const classes = useStyles()

    const { t, i18n } = useTranslation('tracking')

    const selectMap = useMemo(() => {
        if (i18n.language === 'th') {
            return orderStatusToTextMap
        } else {
            return orderStatusToTextMapEng
        }
    }, [i18n.language])

    const handleOnChange = (event, value) => {
        setTab(value)
        onResetOpen('')
    }

    const renderLabelTab = (text, amount = 0, id) => {
        return (
            <Box className={classes.labelWrapper}>
                {text} <Box className={`${classes.circleBox} ${id === tab ? classes.active : classes.normal}`}>{amount}</Box>
            </Box>
        )
    }

    return (
        <Box>
            <Tabs
                className={classes.tabs}
                variant="scrollable"
                scrollButtons="auto"
                indicatorColor="primary"
                value={tab}
                onChange={handleOnChange}
            >
                <Tab label={renderLabelTab(t('all'), data.all?.length, 'all')} value='all' />
                <Tab label={renderLabelTab(selectMap['booking'], data.booking?.length, 'booking')} value='booking' />
                <Tab label={renderLabelTab(selectMap['shipping'], data.shipping?.length, 'shipping')} value='shipping' />
                <Tab label={renderLabelTab(selectMap['complete'], data.complete?.length, 'complete')} value='complete' />
                <Tab label={renderLabelTab(selectMap['cancel'], data.cancel?.length, 'cancel')} value='cancel' />
            </Tabs>
            <Divider />
        </Box>
    )
}

export default TrackingTab